import { MAX_SLIDES_FOR_V2 } from '@/constant/uploadLimits'
import { interpolate } from '@/utils/importProgress.utils'

const SLIDE_LIMIT_ERROR_PATTERN = /limited to (\d+) slides/i

export const getSlideLimitFromImportError = (error) => {
  const match = SLIDE_LIMIT_ERROR_PATTERN.exec(error?.message || '')
  if (!match) return null
  return Number(match[1]) || MAX_SLIDES_FOR_V2
}

export const buildSlideLimitMessage = (i18n, maxSlides) => {
  const args = { maxSlides }
  return [
    i18n.t('Larger file imports coming soon.'),
    interpolate(i18n.t('For now, you can import files up to 50MB and {maxSlides} slides.', args), args),
  ].join(' ')
}
